import React from 'react'
import PropTypes from 'prop-types'
import {
  Center,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import IconButton from '../IconButton/IconButton'
import { colors } from '../../utils/theme/styles'

export default function ConfirmModal({
  isOpen,
  onClose,
  onContinue,
  size = 'xl',
  title,
  children,
  textButton,
  noButton,
}) {
  return (
    <Modal size={size} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius=" 15px">
        {title && (
          <ModalHeader
            h="56px"
            borderRadius=" 15px 15px 0px 0px"
            bgColor={colors.gray[600]}
          >
            <Heading textAlign="left" color={colors.gray[50]} variant="h4">
              {title}
            </Heading>
          </ModalHeader>
        )}
        <ModalCloseButton mt="4px" alignSelf="center" color={colors.gray[50]} />
        <ModalBody p="23px">{children}</ModalBody>

        {!noButton && (
          <ModalFooter p="32px" h="56px" w="100%">
            <Center h="56px" w="100%">
              <HStack>
                <IconButton
                  w="253px"
                  text={textButton}
                  icon={faCheckCircle}
                  variant="primary"
                  onClick={onContinue}
                />
              </HStack>
            </Center>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  size: PropTypes.string,
  textButton: PropTypes.string,
  title: PropTypes.string,
  noButton: PropTypes.bool,
}
